import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VueApexCharts from 'vue-apexcharts';
import Icon from '@comp/Icon.vue';
import SelectInput from '@comp/forms/inputs/SelectInput.vue';
import CupIcon from '!!url-loader?!@static/icons/s-cup.svg';
import { profileClient } from '@api/profile';
import moment from 'moment';
import { VProgressCircular } from 'vuetify/lib';
export default {
  name: 'WinningProfit',
  components: {
    apexchart: VueApexCharts,
    Icon: Icon,
    SelectInput: SelectInput,
    VProgressCircular: VProgressCircular
  },
  props: {
    chartDates: Array,
    chartSeries: Array,
    leagueList: Array,
    leagueSelected: String
  },
  data: function data() {
    return {
      CupIcon: CupIcon,
      showChart: false,
      chartEmty: false,
      series: [],
      chartOptions: {
        chart: {
          toolbar: {
            show: false
          }
        },
        xaxis: {
          labels: {
            style: {
              colors: '#B6C0CE',
              fontSize: '12px',
              fontFamily: '',
              cssClass: 'apexcharts-xaxis-label'
            }
          },
          axisTicks: {
            show: true,
            borderType: 'solid',
            height: 5,
            offsetX: 0,
            offsetY: 0
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function formatter(val, _ref) {
            var seriesIndex = _ref.seriesIndex,
                dataPointIndex = _ref.dataPointIndex,
                w = _ref.w;
            val > 0 ? w.config.dataLabels.style.colors[seriesIndex] = '#14A757' : val === 0 ? w.config.dataLabels.style.colors[seriesIndex] = '#34383d' : w.config.dataLabels.style.colors[seriesIndex] = '#EB5757';
            return val > 0 ? val.toLocaleString(undefined, {
              useGrouping: true,
              maximumFractionDigits: 0
            }) : val === 0 ? '' : '(' + Math.abs(val).toLocaleString(undefined, {
              useGrouping: true,
              maximumFractionDigits: 0
            }) + ')';
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            fontFamily: '',
            colors: []
          }
        },
        plotOptions: {
          bar: {
            columnWidth: '8px',
            dataLabels: {
              position: 'top'
            }
          }
        },
        grid: {
          row: {
            colors: ['#fff']
          }
        },
        tooltip: {
          enabled: false
        },
        yaxis: {
          show: true,
          labels: {
            formatter: function formatter(y, index) {
              if (y == 0) {
                return 0;
              } else {
                return y > 0 ? '$ ' + y.toLocaleString(undefined, {
                  useGrouping: true,
                  maximumFractionDigits: 0
                }) : '$(' + Math.abs(y).toLocaleString(undefined, {
                  useGrouping: true,
                  maximumFractionDigits: 0
                }) + ')';
              }
            },
            minWidth: 52,
            style: {
              fontSize: '12px',
              fontFamily: '',
              color: '#B6C0CE'
            }
          }
        },
        colors: ['#14A757']
      }
    };
  },
  watch: {
    chartSeries: function chartSeries() {
      var _this = this;

      this.showChart = false;
      setTimeout(function () {
        _this.updateChart();
      }, 500);
    }
  },
  methods: {
    updateChart: function updateChart() {
      var yaxis = {
        min: undefined,
        max: undefined,
        tickAmount: undefined
      };
      var minValueSeries = this.chartSeries.filter(function (i) {
        return i < 0;
      });
      var maxValueSeries = this.chartSeries.filter(function (i) {
        return i > 0;
      });
      var minValue = 0;
      var maxValue = 0;

      if (minValueSeries.length) {
        minValue = Math.min.apply(null, minValueSeries);
      }

      if (maxValueSeries.length) {
        maxValue = Math.max.apply(null, maxValueSeries);
      }

      if (minValue !== 0 || maxValue !== 0) {
        var min = minValue - Math.abs(minValue) * 0.2;
        var max = maxValue + maxValue * 0.2;
        var divider = (Math.abs(min) + max) / 5;
        var dividerRound = Math.round(divider / 100) * 100;
        dividerRound = dividerRound === 0 ? 100 : dividerRound;
        var minRound = Math.floor(min / dividerRound) * dividerRound;
        var maxRound = Math.ceil(max / dividerRound) * dividerRound;

        if (minRound !== 0) {
          minRound = minRound - dividerRound;
        }

        yaxis = {
          min: minRound,
          max: maxRound,
          tickAmount: (Math.abs(minRound) + maxRound) / dividerRound
        };
      }

      this.chartOptions = _objectSpread(_objectSpread({}, this.chartOptions), {}, {
        xaxis: _objectSpread(_objectSpread({}, this.chartOptions.xaxis), {}, {
          categories: _toConsumableArray(this.chartDates)
        }),
        yaxis: _objectSpread(_objectSpread({}, this.chartOptions.yaxis), yaxis),
        plotOptions: {
          bar: _objectSpread(_objectSpread({}, this.chartOptions.plotOptions.bar), {}, {
            colors: {
              ranges: [{
                from: Math.min.apply(null, this.chartSeries.filter(function (i) {
                  return i < 0;
                })),
                to: 0,
                color: '#EB5757'
              }]
            }
          })
        }
      });
      this.series = [{
        name: '',
        data: _toConsumableArray(this.chartSeries)
      }];
      this.showChart = true;
      this.chartEmty = !Boolean(this.chartSeries.length);
    }
  },
  mounted: function mounted() {
    this.updateChart();
  }
};